import { HeaderOptionName } from "@/enums/enums";
import { GetCredential, GetExecutiveSummaryDocumentData } from "@/helper/documentFacadeHelper";
import { CredentialModel, DocumentTemplateHeaderTypeModel } from "@/model/document/documentModel";
import {
  ExecutiveSummaryDocumentDetailModel,
  ExecutiveSummaryOnlineViewModel,
} from "@/model/document/executiveSummaryModel";
import { SettingExecutiveSummaryDocumentTemplateModel } from "@/model/document/settingDocumentTemplate";

export function ConvertToExecutiveSummaryOnlineView(detail: any): ExecutiveSummaryOnlineViewModel {
  const onlineViewModel: ExecutiveSummaryOnlineViewModel = new ExecutiveSummaryOnlineViewModel();
  if (detail) {
    const documentDetailModel: ExecutiveSummaryDocumentDetailModel = new ExecutiveSummaryDocumentDetailModel();
    documentDetailModel.version = detail.document.version;
    documentDetailModel.data = GetExecutiveSummaryDocumentData(detail.document.data);
    onlineViewModel.document = documentDetailModel;
    onlineViewModel.transactionId = detail.transactionId;
    onlineViewModel.transactionType = detail.transactionType;
    onlineViewModel.financeType = detail.financeType;
    onlineViewModel.expenseType = detail.expenseType;
    onlineViewModel.template = detail.template ? detail.template.data : GetExecutiveSummarySettingDocument();
    onlineViewModel.credential = detail.credential ? GetCredential(detail.credential) : new CredentialModel();
    onlineViewModel.headerOptionType = detail.headerOptionType;
  }
  return onlineViewModel;
}

export function GetExecutiveSummarySettingDocument(): SettingExecutiveSummaryDocumentTemplateModel {
  let settingTemplate = new SettingExecutiveSummaryDocumentTemplateModel();
  settingTemplate = {
    documentName: {
      headerOptionType: HeaderOptionName.None,
      isShowElement: true,
      value: "Executive_Summary",
    },
    header: {
      originalAmount: 1,
      isShowCreateDate: true,
      isShowCreateUser: true,
      isShowPeriodDate: true,
    },
    merchantLogo: {
      isShowElement: true,
      value: "",
    },
  };
  return settingTemplate;
}

export function PrepareExecutiveSummaryDocumentInputData(input: DocumentTemplateHeaderTypeModel){
  const data = {
    executiveSummaryId: input.transactionId,
      option: {
        documentVersion: 0,
        templateVersion: 0,
        headerOptionType: input.headerType,
        language: 1,
      },
  };
  return data;
}

export function PrepareExecutiveSummaryDocumentPublicLinkInputData(input: DocumentTemplateHeaderTypeModel){
  const data = {
    executiveSummaryId: input.transactionId,
      option: {
        documentVersion: 0,
        templateVersion: 0,
        headerOptionType: input.headerType,
        language: 1,
      },
  };
  return data;
}
